module.exports = __webpack_public_path__ + "assets/img/PrizePool.3731c016.png";